let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lVBNt")).then(() => parcelRequire('h0DUZ'));